import { render, staticRenderFns } from "./MikuDrawerFooterImage.vue?vue&type=template&id=2a3a80e3&"
import script from "./MikuDrawerFooterImage.vue?vue&type=script&lang=js&"
export * from "./MikuDrawerFooterImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VHover,VImg,VSlideXReverseTransition,VSlideXTransition,VThemeProvider})
